<template>
    <BigCard title="Secteurs d'activites">
        <template slot="icon">
            <svg
                class="p-2"
                width="40"
                height="40"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M15.2503 9.44368V14.5784H16.0101V16.098H0.814004V14.5784H1.57381V9.44368C1.10605 9.13147 0.722609 8.7086 0.457518 8.21262C0.192428 7.71663 0.0538894 7.16287 0.0541997 6.60049C0.0541997 5.97213 0.224396 5.36657 0.535156 4.85066L2.59574 1.28186C2.66243 1.16636 2.75834 1.07045 2.87384 1.00376C2.98934 0.937075 3.12036 0.901966 3.25373 0.901962H13.5711C13.7045 0.901966 13.8355 0.937075 13.951 1.00376C14.0665 1.07045 14.1624 1.16636 14.2291 1.28186L16.2821 4.83927C16.7354 5.59213 16.8811 6.49073 16.6889 7.34825C16.4967 8.20576 15.9815 8.95624 15.2503 9.44368ZM13.7307 9.99833C13.2083 10.0569 12.6794 9.99419 12.1852 9.81496C11.691 9.63573 11.2448 9.34486 10.8814 8.965C10.5624 9.29861 10.1792 9.56412 9.75478 9.74551C9.33036 9.9269 8.87359 10.0204 8.41204 10.0204C7.9506 10.0206 7.4939 9.92733 7.06949 9.74621C6.64508 9.56509 6.26177 9.29985 5.94268 8.96652C5.57921 9.34625 5.13301 9.63697 4.63882 9.81607C4.14463 9.99516 3.61577 10.0578 3.09342 9.99909V14.5784H13.7307V9.99909V9.99833ZM3.6929 2.42157L1.8443 5.62262C1.66466 6.06646 1.65927 6.56176 1.8292 7.0094C1.99913 7.45704 2.33185 7.824 2.76076 8.03682C3.18967 8.24964 3.68313 8.29263 4.14239 8.15719C4.60164 8.02175 4.9928 7.71786 5.23758 7.30635C5.49212 6.67039 6.39248 6.67039 6.64778 7.30635C6.78857 7.65922 7.03194 7.96176 7.34644 8.17488C7.66094 8.38801 8.03213 8.50194 8.41204 8.50194C8.79196 8.50194 9.16315 8.38801 9.47765 8.17488C9.79215 7.96176 10.0355 7.65922 10.1763 7.30635C10.4308 6.67039 11.3312 6.67039 11.5865 7.30635C11.6851 7.54907 11.8329 7.76877 12.0205 7.95163C12.2081 8.1345 12.4315 8.27658 12.6766 8.36895C12.9218 8.46132 13.1834 8.50198 13.445 8.48836C13.7067 8.47475 13.9626 8.40717 14.1969 8.28986C14.4311 8.17255 14.6386 8.00805 14.8062 7.8067C14.9738 7.60536 15.098 7.37151 15.1709 7.11987C15.2437 6.86823 15.2638 6.60424 15.2297 6.34448C15.1957 6.08472 15.1082 5.83481 14.9729 5.61047L13.1304 2.42157H3.69366H3.6929Z"
                    fill="white"
                />
            </svg>
        </template>
        <template>
            <div class="flex justify-center content-center py-7">
                <apexchart
                    class="w-full"
                    type="pie"
                    :options="chartOptions"
                    :series="series"
                ></apexchart>
            </div>
        </template>
    </BigCard>
</template>

<script>
import BigCard from "../cardWithIcon.vue";
import VueApexCharts from "vue-apexcharts";

export default {
    components: {
        BigCard,
        VueApexCharts
    },
    created() {
        this.secteurs[Symbol.iterator] = function*() {
            yield* [...this.entries()].sort((a, b) => b[1] - a[1]);
        };
        let counter = 0;
        let autreValue = 0;
        for (let [key, value] of this.secteurs) {
            if (counter < 21) {
                this.chartOptions.labels.push(key);
                this.series.push(value);
            } else {
                autreValue += value;
            }
            counter++;
        }
        this.chartOptions.labels.push("Autres");
        this.series.push(autreValue);
    },

    props: {
        secteurs: {
            type: Map,
            required: true
        }
    },
    data() {
        return {
            series: [],
            chartOptions: {
                chart: {
                    width: 380,
                    type: "pie"
                },
                legend: {
                    show: false
                },
                labels: [],
                colors: ["#FBBF24", "#FB923C", "#818CF8", "#34D399"],
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: "bottom"
                            }
                        }
                    }
                ]
            }
        };
    }
};
</script>

<style></style>
